import { Contact } from "../types/Contact";
import GoogleMapsIcon from "../components/gfx/GoogleMapLogo";

export const getGoogleMapsLink = (contact: Contact) => {
  return (
    <a
      className="muted"
      target="_blank"
      rel="noreferrer"
      href={
        "https://www.google.com/maps/search/?api=1&query=" +
        [contact.street, contact.postalCode, contact.city].join(" ")
      }
    >
      Adresse in Google Maps öffnen
      <GoogleMapsIcon style={{ marginLeft: 4, marginTop: -7 }} />
    </a>
  );
};
